<template>

    <article class="landing">

        <hero v-if="!($md.phone() && !$md.tablet())"></hero>
        <mobile-hero v-if="($md.phone() && !$md.tablet())"></mobile-hero>

        <about></about>

        <contact></contact>

    </article>

</template>


<script>

    import Hero from "./Hero";
    import About from "./About";
    import Contact from "./Contact";
    import MobileHero from './MobileHero';

    export default {

        name: 'Landing',

        components: {
            MobileHero,
            Hero,
            About,
            Contact
        },

        data() {
            return {

            };
        },

        computed: {

        },

        created() {

        },

        mounted() {

        },

        methods: {

        }

    }

</script>


<style lang="scss" scoped>

    article {
        position: relative;
    }

    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

</style>
